export default () => {
    const meta = document.querySelector('meta[name="member"]');
    if (meta && parseInt(meta.getAttribute('value')) > 0) {
        return true;
    }
    return false;
}
